import styled, { css } from 'styled-components';
import { colorClaro, colorFluerecente, colorOscuro, colorPrincipal, fuentePrincipal } from '../variables';

export const ContactIcons = styled.ul`
  list-style: none;
  display: flex;
  justify-content: center;
  gap: 1em;
  & a{
      display: flex;
      flex-direction: column;
      text-align: center;
      justify-content: center;
      align-items: center;
      text-decoration: none;
      color: ${colorOscuro};
      border-radius: 8px;
      padding: 1em 3em;
      transition: .3s;
      & svg{
          font-size: 3rem;
          margin-bottom: 16px;
      }

      &:hover{
        background: white;
      }

  }

  @media (max-width: 500px){
    flex-direction: column;
  }
`;


export const Form = styled.form`
  background: white;
  width: 90%;
  margin: 4em auto 0;
  border-radius: 8px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: repeat(4, 1fr);
  padding: 3em;
  gap: 2em 3em;
  grid-template-areas:'name message'
                      'email message'
                      'project message'
                      'button button';
  @media (max-width: 500px){
    width: auto;
    padding: 3em 1em;
    grid-template-columns: 1fr;
    grid-template-areas: 'name'
                         'email'
                         'project'
                         'message'
                         'button';
  }
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  grid-area: ${props => props.area};
  & label{
      color: ${colorFluerecente};
      margin-bottom: 1em;
    }
    & textarea{
        background: ${colorClaro};
        border-radius: 8px;
        height: 100%;
        border: none;
        padding: 16px;
        font-family: ${fuentePrincipal};
        border: 2px solid ${colorClaro};
        transition: .3s;
        &:focus{
            outline: none;
            color: ${colorFluerecente};
            border-color: ${colorFluerecente};
        }
    }
`;

export const InputGroup = styled.div`
  display: flex;
  position: relative;

  & svg,& input{
      border: 2px solid #EDEDED;
      padding: 12px 16px; //.5em
      border-radius: 8px 0 0 8px;
      transition: .3s;
  }

  & svg{
      border-right: none;
      border: none;
      font-size: 1.5rem;
      color: ${colorFluerecente};
      box-sizing: initial !important;
      position: absolute;
  }

  & input{
      border: 2px solid #EDEDED;
      padding: 1em 1em 1em 4em;
      font-family: ${fuentePrincipal};
      border-radius: 8px;
      width: 100%;
      &:focus{
          outline: none;
          border-color: ${colorFluerecente};
          color: ${colorFluerecente};
          & + svg{
              border-color: ${colorFluerecente};
          }
      }
  }
`;

export const FormButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  grid-area: button;
  margin-top: 2em;
  align-items: center;
  & button{
      background: ${colorFluerecente};
      font-family: ${fuentePrincipal};
      border: none;
      padding: .1em 2em;
      color: white;
      border-radius: 8px;
      /* display: flex; */
      font-size: 2rem;
      height: fit-content;
      cursor: pointer;
  }
`;

export const LoaderContainer = styled.div`
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
  & div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 64px;
    height: 64px;
    margin: 8px;
    border: 15px solid ${colorPrincipal};
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: ${colorPrincipal} transparent transparent transparent;
  }
  & div:nth-child(1) {
    animation-delay: -0.45s;
  }
  & div:nth-child(2) {
    animation-delay: -0.3s;
  }
  & div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

`;

const infoBox = ()=> css`
  padding: .2em 1em;
  margin-left: 2em;
  border-radius: 8px;
  display: flex;
  align-items: center;
  & svg{
    font-size: 1.5rem;
    margin-right: 1rem;
  }
  & h3,& svg{
    color: white;
  }
`

export const Success = styled.div`
  background: #81c784;
  ${infoBox}
`;

export const Error = styled.div`
  background: #e57373;
  ${infoBox}
`;